import { PublicationType, SavePublicationResultDto } from "generated/CoreApi_v1";
import { publicationFactory } from "views/knowledge/feed/FeedHelpers";

///
interface IProps {
    publicationId: string | null;
    publicationType: PublicationType;
    masterPublicationId?: string | null;
    listExclusiveId?: string | null;
    masterTitle?: string | null;
    onClose: (changed: boolean) => void;
}
export const EditPublicationFactory = ({ publicationId, publicationType, masterPublicationId, masterTitle, listExclusiveId, onClose }: IProps) => {
    let dialog: any = null;

    const processReturn = (r: SavePublicationResultDto | null) => {
        onClose(r?.success === true);
    };

    if (publicationId != null) {
        switch (publicationType) {
            case PublicationType.List: {
                dialog = publicationFactory(publicationId, publicationType, processReturn, { isPublic: true });
                break;
            }
            default: {
                if (masterPublicationId)
                  dialog = publicationFactory(publicationId, publicationType, processReturn, { parent: { parentId: masterPublicationId, parentTitle: masterTitle ?? "" } });
                else if (listExclusiveId)
                  dialog = publicationFactory(publicationId, publicationType, processReturn, { list: { listExclusiveId } });
                else
                    dialog = publicationFactory(publicationId, publicationType, processReturn);
                break;
            }
        }
    }

    return dialog;
};
